import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, Button, Card, Grid } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import CrmReportFilters from "../components/CrmReportFilters";
import CrmReportTable from "../components/CrmReportTable";
import { fetchCrmReport } from "../CrmReportThunk";
import ReportDom from "../../../components/common/ReportDom";

const LeadReports = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();

  const screens = Grid.useBreakpoint();

  const { filters } = useSelector(
    (state) => state.crmReport
  );

  const reportRef = useRef(null);

  useEffect(() => {
    dispatch(fetchCrmReport(filters));
  }, []);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "CRM Lead Report",
    removeAfterPrint: true,
  });

  return (
    <>
      <CrmReportFilters messageApi={message} />

      <Card
        title="Lead Status Report"
        extra={
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
          >
            {!screens.xs && "Print"}
          </Button>
        }
      >
        <CrmReportTable />
      </Card>

      <div
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
        }}
      >
        <ReportDom
          ref={reportRef}
          title="CRM Lead Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <CrmReportTable printMode />
          )}
        />
      </div>
    </>
  );
};

export default LeadReports;